import Tool, { type ToolHandler } from '../Tool';
import type { AssistantToolCall } from 'components/framework/models';
import type Agent from '../../agents/Agent';

/**
 * Tool handler for the Reports::GetReportDataTool - provides frontend content for some reports.
 * The tool only requests frontend content if the report type is one that provides it.
 */
const getReportDataToolHandler: ToolHandler = {
  provideToolCallData(
    toolCall: AssistantToolCall,
    agent: Agent
  ): Object | false {
    const node: HTMLElement | null = document.querySelector(
      '[data-agent-report-data]'
    );

    if (!node) return false;

    try {
      return {
        reportData: JSON.parse(node.dataset.agentReportData || '{}') as Object,
      };
    } catch (error) {
      console.error('Error parsing report data');
      return false;
    }
  },
};

Tool.register('Reports::GetReportDataTool', getReportDataToolHandler);
